<template>
  <div class="row px-4 sizer">
    <div class="col-12" style="padding: 0">
      <ibox title="Banners">
        <template slot="content" slot-scope="{ setLoading }">
          <Form
            slot="content"
            @loading="setLoading"
          />
        </template>
      </ibox>
    </div>
  </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import Form from '@/components/VNFR/Banners/Form'

export default {
  name: 'BaseAdd',
  components: {
    Form,
    Ibox
  },
  data() {
    return {
      title_edit: 'Edycja produktu',
      title_dismiss: 'Usuń bazę'
    }
  },
  methods: {
    updateTitle( event ) {
      this.title_edit = event
    }
  }
}
</script>

<style>
.sizer {
  font-size: 14px !important;
}
input[type="radio"], input[type="checkbox"] {
  width: 15px;
  height: 15px;
}
.container {
  max-width: 1320px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
